<template>
    <a :href="`mailto:${email}`">
        <slot>
            {{ email }}
        </slot>
    </a>
</template>

<script>
    export default {
        props: {
            email: {
                type: String,
                required: true
            }
        }
    }
</script>
